import React from 'react';

class Page404 extends React.Component {
  render() {
    return (
      <h1>Page 404</h1>
    );
  }
}

export default Page404;




// WEBPACK FOOTER //
// ./src/components/Page404/component.jsx